"use strict";

exports.__esModule = true;
exports.dataItemChartCardProps = exports.DataItemChartWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DataItemChartElement = require("./DataItemChartElement");
var _ChartCard = require("../common/ChartCard");
var _DataItemChartFields = require("./DataItemChartFields");
var _DataItemChartHeader = require("./DataItemChartHeader");
var _DataItemChartThumbnail = require("./DataItemChartThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// The chart draws its own legend and axes, so a short widget keeps every
// pixel for them and the card names it only when there is room.
var dataItemChartCardProps = exports.dataItemChartCardProps = function dataItemChartCardProps(props) {
  return {
    title: props.height >= _ChartCard.SHORT_CARD_HEIGHT ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DataItemChartWidget.card.title",
      defaultMessage: "Data items"
    }) : undefined
  };
};
var DataItemChartWidget = exports.DataItemChartWidget = {
  name: "DataItemChart",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DataItemChartWidget.label",
    defaultMessage: "Data Item Chart"
  }),
  icon: "timeline-area-chart",
  group: _widgetGroups.RAW_DATA_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "DataItemChart",
      props: Object.assign({
        width: 200,
        height: 150,
        showChartTooltip: true,
        showLegend: true,
        dataItemName: "XM1act",
        dataItemIndex: 0,
        dataItemSource: "realtime",
        chartType: "LINE_CHART",
        chartCurve: "stepAfter",
        scatterPlotRadius: 5,
        color: "#1678c2"
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["color", "dataItemIndex", "dataItemName"],
  requiresProps: ["x", "y", "width", "height", "dataItemSource"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 200,
      min: 64,
      max: 3840
    },
    height: {
      "default": 150,
      min: 64,
      max: 2160
    }
  },
  components: {
    Header: _DataItemChartHeader.DataItemChartHeader,
    Element: (0, _ChartCard.withChartCard)(_DataItemChartElement.DataItemChartElement, dataItemChartCardProps),
    Fields: _DataItemChartFields.DataItemChartFields,
    Thumbnail: _DataItemChartThumbnail.DataItemChartThumbnail
  }
};